import {
	styled,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
} from "@mui/material";
import { types } from "api";
import { Order } from "helpers/tableComparator";
import React from "react";

const PREFIX = "RegisteredUserTableHead";

const classes = {
	root: `${PREFIX}-root`,
	visuallyHidden: `${PREFIX}-visuallyHidden`,
};

const StyledTableHead = styled(TableHead)({
	[`& .${classes.root}`]: {
		width: "100%",
	},
	[`& .${classes.visuallyHidden}`]: {
		border: 0,
		clip: "rect(0 0 0 0)",
		height: 1,
		margin: -1,
		overflow: "hidden",
		padding: 0,
		position: "absolute",
		top: 20,
		width: 1,
	},
});

interface HeadCell {
	id: keyof types.RegisteredUser;
	label: string;
	numeric: boolean;
}

const headCells: HeadCell[] = [
	{
		id: "firstName",
		numeric: false,
		label: "First Name",
	},
	{
		id: "lastName",
		numeric: false,
		label: "Last Name",
	},
	{
		id: "role",
		numeric: false,
		label: "Roles",
	},
	{
		id: "email",
		numeric: false,
		label: "Email",
	},
	{
		id: "userId",
		numeric: false,
		label: "User Id",
	},
];

export interface RegisteredUserTableHeadProps {
	onRequestSort: (
		event: React.MouseEvent<unknown>,
		property: keyof types.RegisteredUser,
	) => void;
	order: Order;
	orderBy: string;
}

export const RegisteredUserTableHead = ({
	order,
	orderBy,
	onRequestSort,
}: RegisteredUserTableHeadProps): JSX.Element => {
	const createSortHandler =
		(property: keyof types.RegisteredUser) =>
		(event: React.MouseEvent<unknown>) => {
			onRequestSort(event, property);
		};

	return (
		<StyledTableHead>
			<TableRow>
				{headCells.map((headCell) => (
					<TableCell
						key={headCell.id}
						sortDirection={orderBy === headCell.id ? order : false}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : "asc"}
							onClick={createSortHandler(headCell.id)}
							data-testid="sort-label"
						>
							{headCell.label}
							{orderBy === headCell.id ? (
								<span className={classes.visuallyHidden}>
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</span>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</StyledTableHead>
	);
};
